import BindingContext from '@/BindingContext';
import * as TypeInfo from '@/Utility/TypeInfo';
import SummaryViewTuple from '@/SummaryViews/SummaryViewTuple';
import RADApplication from '@/Management/RADApplication';
import ResourceManager from '@/Management/ResourceManager';
import SummaryViewModel from '@/ViewModels/SummaryViewModel';

export default class SummaryView extends BindingContext {

    /**
     * Beinhaltet den Typ-Namen für die SummaryView
     */
    public typeName: string;

    /**
     * Der Unique-Identifier der SummaryView
     */
    public identifier: string;

    protected tuple: SummaryViewTuple;

    constructor() {
        super();

        this.isDisposable = true;
        this.disposeProperties = this.paramOrDefault(true);
        this.typeName = TypeInfo.getType(self);
        this.identifier = _.uniqueId(this.typeName + '_');
    }

    public getSummaryView(): JQuery {
        throw new Error('Die Funktion "getSummaryView" wurde nicht implementiert');
    }

    /**
     * Erzeugt das SummaryViewTuple und die SummaryView
     */
    public getTuple(): SummaryViewTuple {
        if (this.tuple)
            return this.tuple;

        const $view = this.getSummaryView();
        this.tuple = new SummaryViewTuple(this, $view);
        return this.tuple;
    }

    /**
     * Erstellt ein Element auf Basis eines HTML-Strings und wendet Bindings darauf an
     */
    public applyViewModel(html: string, viewModel: SummaryViewModel): JQuery {
        if (!html)
            return undefined;

        const $element = $(html);

        ko.applyBindings({
            uiElement: this,
            viewModel: viewModel,
            RADApplication: RADApplication,
            ResourceManager: ResourceManager
        }, $element[0]);

        return $element;
    }

    /**
     * Wendet Bindings auf einem HTML-String an
     */
    public applyBindings(element: JQuery<HTMLElement>, bindings: any): void {
        ko.applyBindingsToNode(element[0], $.extend({ uiElement: this }, bindings));
    }
}